import { Box, Group, Paper } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { useState } from 'react';

import ValidationFormFieldAnswersTable from '../../components/validation-form-field-answers-table/validation-form-field-answers-table';
import { useContractsQueries } from '../../lib/queries/contracts';

import { ValidationFormMap } from './components/validation-form-map';
import ErrorPage from './page.error';
import { ValidationFormDetailsPageSkeleton } from './page.skeleton';

import { FullMainHeight } from '@ui';

export function ValidationFormDetailsPage() {
  const { validationFormId } = useParams({
    from: '/_app/os/validation-forms_/$validationFormId',
  });

  const contractsQueries = useContractsQueries();
  const { data } = useSuspenseQuery(
    contractsQueries.validationFormsDetail(Number(validationFormId)),
  );

  const [selectedFieldId, setSelectedFieldId] = useState<number | null>(null);

  const handleSelectField = (fieldId: number) => {
    setSelectedFieldId(fieldId);
  };

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Group justify="space-between">
            <Box>
              <Group gap="xs">
                <span>{data.farm_name}</span>
              </Group>
            </Box>
          </Group>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <Group h="100%" wrap="nowrap">
          <Box h="100%" style={{ minWidth: 400, maxWidth: 500 }}>
            <ValidationFormFieldAnswersTable
              data={data.field_answers}
              onSelectField={handleSelectField}
              selectedFieldId={selectedFieldId}
            />
          </Box>
          <ValidationFormMap
            fieldAnswers={data.field_answers}
            onFieldClick={handleSelectField}
            selectedFieldId={selectedFieldId}
          />
        </Group>
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

ValidationFormDetailsPage.Skeleton = ValidationFormDetailsPageSkeleton;
ValidationFormDetailsPage.Error = ErrorPage;

export default ValidationFormDetailsPage;
